
import { EnumEndpointsName } from "@/constants/app/type";
import { thunks } from "@/lib/redux/thunks";
import { EnumReduces } from "@/lib/redux/type";
import { endpoints } from "@/lib/services";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";

export const generateThunkHandler = (
  builder: ActionReducerMapBuilder<any>,
  reduceName: EnumReduces,
  endpointsName: EnumEndpointsName[]
) => {
  for (let i = 0; i < endpointsName.length; i++) {
    const endpointName = endpointsName[i];

    const thunk = thunks[endpointName]
    const config = (endpoints[reduceName] as any)[endpointName]

    builder
      .addCase(thunk.pending, (state) => {
        state[endpointName].loading = true
        state[endpointName].success = false
        state[endpointName].error = null
      })
      .addCase(thunk.rejected, (state, { payload, error, ...action }) => {
        state[endpointName].loading = false
        state[endpointName].success = false
        state[endpointName].error = payload
        if (config?.callerReject) {
          config?.callerReject(state, { payload, error, ...action }, endpointName)
        }
      })
      .addCase(thunk.fulfilled, (state, action) => {
        state[endpointName].loading = false
        state[endpointName].success = true
        state[endpointName].error = null
        state[endpointName].called = true
        if (config?.caller) {
          config?.caller(state, action, endpointName)
        } else {
          state[endpointName].data = action.payload
        }
      })
  }
}